class UserGeneratedContent extends HTMLElement {
  constructor() {
    super()

    this.carousel = this.querySelector('swiper-container')
  }

  connectedCallback() {
    this.addCarouselParameters()
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 1.33,
      pagination: {
        el: '.ugc__carousel-dots',
        clickable: true
      },
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      roundLenghts: true,
      mousewheel: {
        enabled: true,
        forceToAxis:true,
      },
      breakpoints: {
        560: {
          slidesPerView: 2.2
        },
        860: {
          slidesPerView: 3.2
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 4,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: '.ugc__carousel-nav .carousel-navigation__next',
            prevEl: '.ugc__carousel-nav .carousel-navigation__prev'
          },
        }
      }
    });
    
    this.carousel.initialize();
  }
}

if (!customElements.get('ugc-section'))
  customElements.define('ugc-section', UserGeneratedContent)